export const RELATIONS = [
  "Un enfant",
  "Un petit-enfant",
  "Un arrière-petit-enfant",
  "Une épouse",
  "Un frère / une sœur",
  "Un beau-fils",
  "Une belle-fille",
  "Un arrière-beau-fils",
  "Une arrière-belle-fille",
  "Un neveu",
  "Une nièce",
  "Un cousin",
  "Une cousine",
  "Un ami",
  "Une collectivité",
  "Toute autre personne",
];
